import { createSelector } from '@reduxjs/toolkit';
const selectTextToSpeech = (state) => state.textToSpeech;
export const selectTtsVoices = createSelector([selectTextToSpeech], (textToSpeech) => textToSpeech.ttsVoices);
export const selectTtsBestVoice = createSelector([selectTextToSpeech], (textToSpeech) => textToSpeech.ttsBestVoice);
export const selectTtsError = createSelector([selectTextToSpeech], (textToSpeech) => textToSpeech.ttsError);
export const selectVoicingProfile = createSelector([selectTextToSpeech], (textToSpeech) => textToSpeech.voicingProfile);
export const selectIsUsingTts = createSelector([selectTextToSpeech], (textToSpeech) => textToSpeech.isUsingTts);
